import { useCallback, useState } from 'react';

import { defaultLimit } from 'views/CRM/shared/utils/pagination';

import LeadService from '../services/leadService';

export const useListLeads = ({ recordTypeId, sortConfig }) => {
  const [leads, setLeads] = useState(null);
  const [totalLeads, setTotalLeads] = useState(0);
  const [isLoadingLeads, setIsLoadingLeads] = useState(false);

  const getLeads = useCallback(
    (page = 1, params = {}) => {
      setIsLoadingLeads(true);

      const orderType =
        sortConfig?.direction === null ||
        sortConfig?.direction === undefined ||
        // Algumas páginas estão passando `ascending` enquanto outras passam `ascendant`. Para evitar modificar muitos arquivos, aceita-se ambos os modos.
        sortConfig?.direction === 'ascending' ||
        sortConfig?.direction === 'ascendant'
          ? 'ASC'
          : 'DESC';

      let orderBy = sortConfig?.key;

      if (orderBy === 'phone') {
        orderBy = 'telephone';
      }

      LeadService.getLeads(
        recordTypeId,
        { ...params, orderType, orderBy },
        { page, limit: defaultLimit }
      )
        .then((response) => {
          setLeads(response.data.data);
          setTotalLeads(response.data.totalRegisters);
        })
        .finally(() => setIsLoadingLeads(false));
    },
    [recordTypeId, sortConfig]
  );

  const getAndReturnLeads = useCallback(
    (page = 1, params = {}, limit = 20) => {
      return LeadService.getLeads(recordTypeId, params, {
        page,
        limit
      });
    },
    [recordTypeId]
  );

  const getReportLeads = useCallback(
    (page = 1, params = {}) => {
      setIsLoadingLeads(true);

      const orderType =
        sortConfig?.direction === null ||
        sortConfig?.direction === undefined ||
        sortConfig?.direction === 'ascending' ||
        sortConfig?.direction === 'ascendant'
          ? 'ASC'
          : 'DESC';

      const orderBy = sortConfig?.key;

      LeadService.getReportLeads(
        recordTypeId,
        { ...params, orderType, orderBy },
        {
          page,
          limit: defaultLimit
        }
      )
        .then((response) => {
          setLeads(response.data.data);
          setTotalLeads(response.data.totalRegisters);
        })
        .finally(() => setIsLoadingLeads(false));
    },
    [recordTypeId, sortConfig]
  );

  const clearLeads = useCallback(() => {
    setLeads(null);
    setTotalLeads(0);
    setIsLoadingLeads(false);
  }, []);

  return {
    leads,
    totalLeads,
    isLoadingLeads,
    getLeads,
    clearLeads,
    getReportLeads,
    getAndReturnLeads
  };
};
